import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiStateService {
  private readonly _hideNavbar$ = new BehaviorSubject<boolean>(false);
  readonly hideNavbar$ = this._hideNavbar$.asObservable();

  setHideNavbar(hide: boolean): void {
    this._hideNavbar$.next(hide);
  }
}